import SubscriptionSelector from './components/SubscriptionSelector';
import useAuth0 from './auth/useAuth0';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LanguageSelector from './components/LanguageSelector';
import { I18nextProvider, useTranslation } from 'react-i18next';
import InfoBox from './components/InfoBox';
import React, { useEffect, useState } from 'react';
import { TLanguage } from './models/languages.type';
import i18nInstance from './i18n';
import useHideObserverErrors from './misc/useHideObserverErrors';
import { isNil } from './misc/is-nil';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00bcd4'
    }
  }
});

const App = (): React.JSX.Element => {
  //This is to prevent the error overlay caused by LastPass
  if (isNil(process.env.NODE_ENV) || process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useHideObserverErrors();
  }
  const { t, i18n } = useTranslation();
  const { subscriptions, tryRedirect } = useAuth0(i18n.language as TLanguage);

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setError(params?.get('error'));
  }, []);

  const setLanguage = (lang: TLanguage): void => {
    void i18n.changeLanguage(lang);
  };

  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18nInstance}>
        <div className='page-container'>
          <div className='d-flex justify-content-between'>
            <div className='logo'></div>
            <LanguageSelector selectedLanguage={i18n.language as TLanguage} setLanguage={setLanguage} />
          </div>
          <div className='content row justify-content-center align-items-center'>
            <div style={{ width: '450px' }}>
              <div className='mb-2'>
                {!isNil(error) && (
                  <InfoBox type='error' closeable={false}>
                    <div className='ml-2'>{t(error)}</div>
                  </InfoBox>
                )}
              </div>
              {subscriptions ? (
                <SubscriptionSelector subscriptions={subscriptions} subscriptionSelected={tryRedirect} />
              ) : (
                <div id='auth0_login' className='auth-login'></div>
              )}
            </div>
          </div>
        </div>
      </I18nextProvider>
    </ThemeProvider>
  );
};

export default App;
